import React from "react";

function Footer() {
  return (
    <footer>
      <p>
        &copy; {new Date().getFullYear()} <span>Konrad Lubowicki</span>
      </p>
    </footer>
  );
}

export default Footer;
